import { ComponentProps, ReactNode } from "react";
import HelperText from "@ingka/helper-text";

type FixaHelperTextProps = ComponentProps<typeof HelperText> & {
  children?: ReactNode | undefined;
  className?: string;
  "data-testid"?: string;
};

function FixaHelperText(props: FixaHelperTextProps) {
  return <HelperText {...props} />;
}

export default FixaHelperText;
